if (!customElements.get('multi-column-slider')) {
  class MultiColumnSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      this.initSlider();
    }

    initSlider() {
      const options = this.swiperOptions;

      this.slider = new Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: options.spaceBetweenMobile || 8,
        resistanceRatio: 0.72,
        watchOverflow: true,
        breakpoints: {
          750: {
            enabled: false,
            spaceBetween: options.spaceBetweenDesktop || 24,
          },
        },
      });
    }
  }

  customElements.define('multi-column-slider', MultiColumnSlider);
}
